import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/disable-cash-collection/';

type DisableParkingCashCollectionFnType = typeof disableParkingCashCollection;

type DTO = {
    parkingId: string;
};

const disableParkingCashCollection = ({ parkingId, ...data }: DTO): Promise<string> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseDisableParkingCashCollectionOptions
    extends MutationConfig<DisableParkingCashCollectionFnType, GeneralSmartParkError> {}

const useDisableParkingCashCollection = (options: UseDisableParkingCashCollectionOptions = {}) =>
    useMutation({
        mutationFn: disableParkingCashCollection,
        ...options,
    });

export { useDisableParkingCashCollection, disableParkingCashCollection, RESOURCE };
